function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "calender_icon");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0.833 33.5766 0.833 33.5766 31.9999 0 31.9999"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile---Portal-/-Customer-Service",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Portal-Summary/-Filter",
  transform: "translate(-27.000000, -627.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "calender_icon",
  transform: "translate(27.000000, 626.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(0.000000, 0.167200)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.7546,30.6329 L1.8226,30.6329 C1.5716,30.6329 1.3666,30.4279 1.3666,30.1769 L1.3666,10.5769 L32.2096,10.5769 L32.2096,30.1769 C32.2096,30.4279 32.0056,30.6329 31.7546,30.6329 M1.8226,5.1219 L8.3176,5.1219 L8.3176,7.5339 C8.3176,7.9109 8.6236,8.2169 9.0016,8.2169 C9.3786,8.2169 9.6856,7.9109 9.6856,7.5339 L9.6856,5.1219 L23.8926,5.1219 L23.8926,7.5339 C23.8926,7.9109 24.1986,8.2169 24.5756,8.2169 C24.9536,8.2169 25.2596,7.9109 25.2596,7.5339 L25.2596,5.1219 L31.7546,5.1219 C32.0056,5.1219 32.2096,5.3269 32.2096,5.5779 L32.2096,9.2099 L1.3666,9.2099 L1.3666,5.5779 C1.3666,5.3269 1.5716,5.1219 1.8226,5.1219 M31.7546,3.7549 L25.2596,3.7549 L25.2596,1.5169 C25.2596,1.1389 24.9536,0.8329 24.5756,0.8329 C24.1986,0.8329 23.8926,1.1389 23.8926,1.5169 L23.8926,3.7549 L9.6856,3.7549 L9.6856,1.5169 C9.6856,1.1389 9.3786,0.8329 9.0016,0.8329 C8.6236,0.8329 8.3176,1.1389 8.3176,1.5169 L8.3176,3.7549 L1.8226,3.7549 C0.8176,3.7549 -0.0004,4.5729 -0.0004,5.5779 L-0.0004,30.1769 C-0.0004,31.1819 0.8176,31.9999 1.8226,31.9999 L31.7546,31.9999 C32.7596,31.9999 33.5766,31.1819 33.5766,30.1769 L33.5766,5.5779 C33.5766,4.5729 32.7596,3.7549 31.7546,3.7549",
  id: "Fill-1",
  fill: "#0079DB",
  mask: "url(#mask-2)"
}))))));

var SvgCalenderIcon = function SvgCalenderIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "33px",
    viewBox: "0 0 35 33",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalenderIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calender_icon.9da954b8.svg";
export { ForwardRef as ReactComponent };